import request from '@/service/request';
// import { saveAs } from 'file-saver';
// import axios from 'axios';

export function AffineStart(formdata) {
  return request({
    method: 'post',
    url: '/AffineStart',
    data: formdata,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

// export function AffineStart(formdata) {
//   return new Promise((resolve, reject) => {
//     fetch('/AffineStart', {
//       method: 'POST',
//       body: formdata, // 使用 FormData 处理 multipart/form-data
//       credentials: 'include' // 允许携带 cookie
//     })
//     .then(response => {
//       if (!response.ok) {
//         reject(new Error('Network response was not ok ' + response.statusText));
//       }
//       return response.json(); // 解析响应为 JSON
//     })
//     .then(data => {
//       resolve(data); // 将解析后的数据传递给调用者
//     })
//     .catch(error => {
//       reject(error); // 处理错误
//     });
//   });
// }

// export function AffineDownload() {
//   return request.get(`/AffineDownload`);
// }
export function SpliceStart(formdata) {
  return request({
    method: 'post',
    url: '/SpliceStart',
    data: formdata,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

// export function AffineDownload() {
//   return request({
//     method: 'get',
//     url: '/AffineDownload',
//     responseType: 'blob' // 指定响应类型为blob以处理文件下载
//   }).then(response => {
//     const url = window.URL.createObjectURL(new Blob([response.data], {
//       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
//     }));
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', 'AffineConvert.xlsx'); // 指定下载文件名
//     document.body.appendChild(link);
//     link.click();
//     link.remove(); // 移除链接元素
//     window.URL.revokeObjectURL(url);
//   }).catch(error => {
//     console.error('Download error:', error);
//   });
// }

export function AffineDownload() {
  const affineStartResult = localStorage.getItem('affineStartResult');
  let tableName = '';

  // 确保 affineStartResult 存在并且解析出 tableName
  if (affineStartResult) {
    const parsedResult = JSON.parse(affineStartResult);
    tableName = parsedResult.tableName || ''; // 获取 tableName 字段
  }
  return request({
    url: `/AffineDownload?tableName=${tableName}`, // 替换为实际后端API端点
    method: 'get',
    responseType: 'blob',
    // credentials: 'include',
    withCredentials: true,
  });
}

export function SpliceDownload() {
  // 从 localStorage 中读取 SpliceStart 返回的数据
  const storedData = localStorage.getItem('SpliceStart'); // 读取保存的 mockData
  // let tableName = '';

  return request({
    url: `/SpliceDownload?tableName=${encodeURIComponent(storedData)}`, // 替换为实际后端API端点
    method: 'get',
    responseType: 'blob',
    // credentials: 'include',
  });
}

// export default {

// }
